import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/subscribe/page.tsx");
